// extracted by mini-css-extract-plugin
export default {"addFilterBtn":"style_addFilterBtn__E73Hm","addFilterIcon":"style_addFilterIcon__4VLqS","menuPositioner":"style_menuPositioner__nTJu4","goToEnrichment":"style_goToEnrichment__7tX0W"};